import Image from "react-bootstrap/Image";
import imagepresident from "../../assets/President.jpg";
import imagepic2 from "../../assets/pic2.jpg";

export const Team = () => {
  return (
    <div className="album py-5 bg-light">
      <div className="container">
        <div>
          <div className="col d-flex justify-content-center p-5">
            <div className="card shadow-sm">
              <Image
                src={imagepresident}
                className="text-center rounded-top"
                height="300"
                width="300"
              />
              <div className="card-body">
                <p className="fw-bold card-text">Sargis Grigor</p>
                <p className="card-text fw-light">Data analyst</p>
              </div>
            </div>
          </div>
        </div>
        <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">
          <div className="col">
            <div className="card shadow-sm">
              <Image src={imagepic2} className="rounded-top" />
              <div className="card-body">
                <p className="fw-bold card-text">Sargis Grigor</p>
                <p className="card-text fw-light">Data analyst</p>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="card shadow-sm">
              <Image src={imagepic2} className="rounded-top" />
              <div className="card-body">
                <p className="card-text fw-bold">Bagrat Leo</p>
                <p className="card-text fw-light">Data engineer</p>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="card shadow-sm">
              <Image src={imagepic2} className="rounded-top" />
              <div className="card-body">
                <p className="card-text fw-bold">Gor Sargis</p>
                <p className="card-text fw-light">Data analyst</p>
              </div>
            </div>
          </div>

          <div className="col">
            <div className="card shadow-sm">
              <Image src={imagepic2} className="rounded-top" />
              <div className="card-body">
                <p className="card-text fw-bold">Maral Mari</p>
                <p className="card-text fw-light">Data analyst</p>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="card shadow-sm">
              <Image src={imagepic2} className="rounded-top" />
              <div className="card-body">
                <p className="card-text fw-bold">Hakob Jirair</p>
                <p className="card-text fw-light">Data engineer</p>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="card shadow-sm">
              <Image src={imagepic2} className="rounded-top" />
              <div className="card-body">
                <p className="card-text fw-bold">Eva Vosgi</p>
                <p className="card-text fw-light">Data scientist</p>
              </div>
            </div>
          </div>

          <div className="col">
            <div className="card shadow-sm">
              <Image src={imagepic2} className="rounded-top" />
              <div className="card-body">
                <p className="card-text fw-bold">Kohar Marine</p>
                <p className="card-text fw-light">Data scientist</p>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="card shadow-sm">
              <Image src={imagepic2} className="rounded-top" />
              <div className="card-body">
                <p className="card-text fw-bold">Ararat Ohannes</p>
                <p className="card-text fw-light">Data analyst</p>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="card shadow-sm">
              <Image src={imagepic2} className="rounded-top" />
              <div className="card-body">
                <p className="card-text fw-bold">Eduard Vosgi</p>
                <p className="card-text fw-light">Data scientist</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
